import React, { ReactNode } from 'react';

export interface TypographyProps {
	level?: 1 | 2 | 3 | 4 | 5;
	color?: string;
	weight?: string;
	children: ReactNode;
	className?: string;
}

const levelToTag = {
	1: 'h1',
	2: 'h2',
	3: 'h3',
	4: 'h4',
	5: 'h5',
};

const levelToTextSize = {
	1: 'text-[30px]',
	2: 'text-[24px]',
	3: 'text-[20px]',
	4: 'text-[18px]',
	5: 'text-[16px]',
};

export function Typography({
	level = 1,
	color = 'cBlue-800',
	weight = 'font-normal',
	children,
	className = '',
}: TypographyProps) {
	const Tag = levelToTag[level] as keyof JSX.IntrinsicElements;

	return (
		<Tag className={`${levelToTextSize[level]} leading-snug tracking-wide ${weight} text-${color} ${className}`}>
			{children}
		</Tag>
	);
}
